import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import itCommon from './locales/it/common.json';
import enCommon from './locales/en/common.json';

void i18next.use(initReactI18next).init({
  resources: {
    it: { common: itCommon },
    en: { common: enCommon },
  },
  lng: 'it',
  fallbackLng: 'en',
  defaultNS: 'common',
  interpolation: { escapeValue: false },
});

export const i18n = i18next;
